import { render, staticRenderFns } from "./TiersProgress.vue?vue&type=template&id=25bd422e&scoped=true&"
import script from "./TiersProgress.vue?vue&type=script&lang=js&"
export * from "./TiersProgress.vue?vue&type=script&lang=js&"
import style0 from "./TiersProgress.vue?vue&type=style&index=0&id=25bd422e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bd422e",
  null
  
)

export default component.exports